import React, { Component } from 'react';

import Utils from '../modules/Utils';
import ll from '../modules/ll';

import Div from './Div';

class Calculated extends Component {
    constructor(props) {
        super(props);
        this.inputVal = 0;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const data = Utils.get(nextProps, "data");
        const type = Utils.get(data, "props.type");
        const inputVar = Utils.get(data, "props.input");
        const inputVal = Utils.get(this.props, "inputVal");
        let expression = Utils.get(data, "props.expression");
        const outputVar = Utils.get(data, "props.output");

        //const outputVal = Utils.get(this.props, "outputVal");
        console.log(`Recv Props: type: ${type} expression: ${expression} inputVar: ${inputVar}=${inputVal} outputVar: ${outputVar} `);
        if(type == "intdiv" && inputVal != undefined) {
            expression = Utils.empty(expression) ? 10 : parseInt(expression);
            let calculated = parseInt(inputVal/expression);
            //console.log("CALC", expression, inputVal, calculated);
            if (this.inputVal != inputVal) {
                this.inputVal = inputVal;
                this.props.handleSetVal(outputVar, calculated);
            }
        } else if(type == "switch") {
            console.log("SWITCHED!", expression, inputVal);
            if(inputVal != this.inputVal && expression) {
                this.inputVal = inputVal;
                let options = expression.split(",");
                for(let idx in options) {
                    let option = options[idx];
                    let parts = option.split("=");
                    console.log("option", parts);
                    const key = Utils.get(parts, "0");
                    console.log("Key", key, inputVal, key == inputVal);
                    if(key == inputVal) {
                        const val = Utils.get(parts, "1");
                        this.props.handleSetVal(outputVar, val);
                        break;
                    }
                }
            }
        }
    }

  render() {
    return (
        <Div className="CalculatedCard" style={this.props.style} >
            {this.props.outputVal}
        </Div>
    );
  }
}

export default Calculated;